// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ShareRssFeedIconSignature {
  Element: SVGSVGElement;
}

export const ShareRssFeedIcon: TOC<ShareRssFeedIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19 21H21C21 11.075 12.926 3 3 3V5C11.822 5 19 12.178 19 21ZM15 21H13C13 15.484 8.514 11 3 11V9C9.617 9 15 14.383 15 21ZM2 19C2 20.654 3.346 22 5 22C6.654 22 8 20.654 8 19C8 17.346 6.654 16 5 16C3.346 16 2 17.346 2 19ZM4 19C4 18.449 4.449 18 5 18C5.551 18 6 18.449 6 19C6 19.551 5.551 20 5 20C4.449 20 4 19.551 4 19Z"/>
</svg>
</template>;